import { faBars, faChevronDown, faThLarge } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, Divider, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, MenuList, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getImage } from '../../../helpers';
// import logo from '../../../assets/images/logo.png'
import { useLang } from '../../../language';

import './Navleft.scss'

interface INavleft {
    navLinks: Array<any>;
    navGroups?: Array<{ key: string; title: string; icon?: any }>;
    setshowNavLeft?: (boolean: boolean) => boolean,
    showNavLeft?: boolean,
    label?: string
}



const Navleft = ({ navLinks, navGroups = [], setshowNavLeft = (() => false), showNavLeft, label }: INavleft) => {

    const navigate = useNavigate();

    const handleClickNavigateTo = (url: string) => navigate(`/${url}`)

    const Lang = useLang()

    const getPathExact = () => {

        if (process.env.REACT_APP_SUBDOMAIN === '/') {
            return (window.location.pathname).replace(process.env.REACT_APP_SUBDOMAIN || '', '')
        } else {
            return (window.location.pathname).replace(process.env.REACT_APP_SUBDOMAIN || '', '')
        }
    }

    const isExactPath = (original: any) => {
        if (process.env.REACT_APP_SUBDOMAIN === '/') {
            return original === (window.location.pathname || '/')
        } else {
            return original === ((window.location.pathname).replace(process.env.REACT_APP_SUBDOMAIN || '', '') || '/')
        }
    }

    const isIncludePath = (original: any) => {
        if (process.env.REACT_APP_SUBDOMAIN === '/') {
            return (window.location.pathname || '/').includes(original)
        } else {
            return ((window.location.pathname).replace(process.env.REACT_APP_SUBDOMAIN || '', '') || '/').includes(original)
        }
    }

    const handleClickItem = (item: any) => {

        if (window.innerWidth < 900) {
            setshowNavLeft(!showNavLeft)
        }
        if (item.external) {
            window.open(item.link)
        } else {
            navigate(item.link)
        }
    }

    const itemsPorGrupo: Record<string, Array<any>> = navGroups.reduce((acc: Record<string, Array<any>>, grupo) => {
        acc[grupo.key] = navLinks.filter((item: any) => item.group === grupo.key)
        return acc
    }, {})

    const grupoActivo = navGroups.find((grupo) => (itemsPorGrupo[grupo.key] || []).some((item: any) => isIncludePath(item.link)))?.key

    const [gruposAbiertos, setGruposAbiertos] = useState<Record<string, boolean>>({})

    useEffect(() => {

        if (grupoActivo) setGruposAbiertos((prev) => ({ ...prev, [grupoActivo]: true }))

    }, [grupoActivo])

    const renderItem = (item: any, hijo = false) => (
        <ListItemButton className={`LayoutPrimary__Link ${hijo ? 'LayoutPrimary__Link--hijo' : ''} ${item.disabled ? 'LayoutPrimary__Link--disabled' : ''}`}
            selected={isIncludePath(item.link)}
            onClick={() => handleClickItem(item)}
            key={item.link}
        >
            <ListItemIcon className='LayoutPrimary__IconLink'>
                {item.icon}
            </ListItemIcon>
            <ListItemText className='LayoutPrimary__TextLink text-wrap'>{item.title}</ListItemText>
        </ListItemButton>
    )

    return (
        <div className={`LayoutPrimary__Navleft--container`}>
            <div className="LayoutPrimary__NavleftIconBar d-flex align-items-center d-md-none pointer p-2"
                onClick={() => setshowNavLeft(!showNavLeft)}
            >
                <FontAwesomeIcon icon={faBars} className='' style={{ 'fontSize': '1.3rem' }} />
            </div>

            <section className={`LayoutPrimary__Navleft d-flex flex-column`}>
                {/* <img src={logo} alt="" width={150} /> */}

                {/* <Typography variant='body1' className="my-0 py-1 text-center fw-500 mt-3 LayoutPrimary__TextLink">
                    {Lang('MI_COLEGIO')}
                </Typography> */}
                <nav className='LayoutPrimary__Navlinks mb-auto mt-3'>
                    <List>
                        {
                            navGroups.length === 0
                            ?
                            navLinks.map((item: any) => renderItem(item))
                            :
                            <>
                                {navLinks.filter((item: any) => !item.group).map((item: any) => renderItem(item))}

                                {navGroups.map((grupo) => {

                                    const hijos = itemsPorGrupo[grupo.key] || []

                                    // Un grupo sin hijos visibles para este rol no se pinta.
                                    if (!hijos.length) return null

                                    const abierto = gruposAbiertos[grupo.key] ?? (grupo.key === grupoActivo)

                                    return (
                                        <div key={grupo.key}>

                                            <ListItemButton className='LayoutPrimary__Link'
                                                selected={grupo.key === grupoActivo}
                                                onClick={() => setGruposAbiertos((prev) => ({ ...prev, [grupo.key]: !abierto }))}
                                            >
                                                <ListItemIcon className='LayoutPrimary__IconLink'>
                                                    {grupo.icon}
                                                </ListItemIcon>
                                                <ListItemText className='LayoutPrimary__TextLink text-wrap'>{grupo.title}</ListItemText>
                                                <span className={`LayoutPrimary__Caret ${abierto ? 'LayoutPrimary__Caret--abierto' : ''}`}>
                                                    <FontAwesomeIcon icon={faChevronDown} />
                                                </span>
                                            </ListItemButton>

                                            <Collapse in={abierto} timeout='auto'>
                                                <List disablePadding>
                                                    {hijos.map((item: any) => renderItem(item, true))}
                                                </List>
                                            </Collapse>

                                        </div>
                                    )
                                })}
                            </>
                        }
                    </List>
                </nav>

                <img src={getImage('./logov2.png')} alt="" className='LayoutPrimary__Navleft--logo2 d-block mx-auto mb-4' width={200} />

                {/* <section className='LayoutPrimary__navmenu' onClick={() => handleClickNavigateTo('')}>
                    <FontAwesomeIcon icon={faThLarge} className='me-2 fs-5' /> {Lang('MENU_PRINCIPAL')}
                </section> */}
            </section>
            <div id="LayoutPrimary__Navleft--backdrop" onClick={() => setshowNavLeft(!showNavLeft)}></div>
        </div>
    )
}

export default Navleft
